const TOAST_ERRORS = {
  INCORRECT: {
    EMAIL_CONFIRMATION_CODE: 'Confirmation code is incorrect',
    PHONE_CONFIRMATION_CODE: 'Confirmation code is incorrect',
    INVALID_CODE: 'Invalid code',
    LOGIN: 'Invalid user details',
    USER_ALREADY_EXISTS: 'Sorry, that user already exists',
  },
  NO_DATA: {},
  SUBMIT_ERRORS: {
    DEFAULT_ERROR: 'Submit error occurred.',
    IDENTITY_ERROR: 'Identity error occurred',
  },
};

export const COMMON_MESSAGES = {
  PLEASE_TRY_AGAIN: 'Please try again',
  PASSWORD_UPDATED_SUCCESSFULLY: 'Password updated successfully',
  PROBLEM_PROCESSING_REQUEST_TRY_AGAIN:
    'There was a problem processing the request. Please try again',
  SOMETHING_WENT_WRONG: 'Something went wrong',
  SOMETHING_WENT_WRONG_TRY_AGAIN: 'Something went wrong. Please try again.',
};

export const PAYMENT_ERROR_MESSAGES = {
  NO_FUNDS_ON_CARD: 'Make sure your card has enough funds',
  TRY_AGAIN_OR_CHOOSE_ANOTHER_METHOD: 'Than try again or choose another method',
};

const SIGN_UP_ERROR_RESPONSES = {
  userAlreadyExists: 'User already exists',
};

export const SIGN_UP_ERRORS = {
  [SIGN_UP_ERROR_RESPONSES.userAlreadyExists]:
    TOAST_ERRORS.INCORRECT.USER_ALREADY_EXISTS,
};
